var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('strong',[_vm._v(_vm._s(_setup.tip_header)+":")]),_c('br'),_c('p',{domProps:{"innerHTML":_vm._s(_setup.tip)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }